import React from 'react'
import PropTypes from 'prop-types'
import {FaIcon} from "../../../../shared/components";

const ViewFilterSimGolf = ({ listView, calendarView, setListView , setCalendarView, onChange }) => {
  const handleClick = (view_type) => {
    if (view_type === 'list') {
      setListView(true)
      setCalendarView(false)
      onChange('viewType', 'list')
    } else {
      setListView(false)
      setCalendarView(true)
      onChange('viewType', 'calendar')
    }
  };

  return (
    <span className='view_filters_container hidden-md'>
      <button className={`view_list_button ${ listView ? '' : 'disabled' }`} onClick={ () => handleClick('list') } >
        <FaIcon icon={ 'grip-lines' } />
        { window.I18n.t('customer_center_comp.components.sim_golf_labels.list') }
      </button>
      <button className={`view_calendar_button ${ calendarView ? '' : 'disabled' }`} onClick={ () => handleClick('calendar') } >
        <FaIcon icon={ 'calendar-days' } />
        { window.I18n.t('customer_center_comp.components.sim_golf_labels.calendar') }
      </button>
    </span>
  );
}

ViewFilterSimGolf.propTypes = {
  listView: PropTypes.bool.isRequired,
  calendarView: PropTypes.bool.isRequired,
  setListView: PropTypes.func.isRequired,
  setCalendarView: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ViewFilterSimGolf